const formHelpers = require("../components/formErrors.js");
const utils = require("../components/utils");
const formContactUs = $("form.contactUs");
const recaptcha = require("google/recaptcha");
const selectSubject = formContactUs.find("select.contact-us-subject");
const newsletterAgreement = $("#contact-accept-newsletter-subscription");
const focusField = require("../components/focusField");
const contactAdditionalData = $(".contactAdditionalData");

/**
* Resets the contact additional fields
*/
function resetContactAdditionalFields() {
    var $additionalDataFields = contactAdditionalData.find("select");
    var $currentField = null;
    $additionalDataFields.each(function () {
        $currentField = $(this);
        $currentField.val($currentField.find("option[selected]").removeAttr("selected"));
        $currentField.val($currentField.find("option:first").attr("selected", "selected").trigger("change"));
    });
}

/**
* Sets the required attribute of the given fields
* @param {Array} fields - array of fields to set required attribute
* @param {boolean} isRequired - whether the fields should be required
*/
function setFieldsRequired(fields, isRequired) {
    fields.forEach(function (field) {
        $(field).prop("required", isRequired);
    });
}

module.exports = {
    updateContactSubjectLabelledBy: function () {
        utils.updateLabelByComboBox($("#contact-subject"));
    },
    showTopicDropdown: function () {
        selectSubject.change(function (e) {
            e.preventDefault();
            const destinationDropdown = formContactUs.find("select.contact-us-topic");
            destinationDropdown.empty();
            const selectedSubject = selectSubject.val();
            formContactUs.find(`select.contact-topic-${selectedSubject}`).children().clone(true).appendTo(destinationDropdown);
            if (selectSubject.find(":selected").attr("data-order")) {
                formContactUs.find("input#contact-order-number").addClass("required");
            }
            $("select.contact-us-topic").select2({
                minimumResultsForSearch: -1
            });
            if ($(".form-control.contact-us-topic option").length > 1) {
                var $parentForm = $(this).closest("form");

                $parentForm.find(".form-group.contact-us-topic .select2-selection--single").addClass("change-bg");

                $parentForm.trigger("topicDropdownChanged");
            }
            utils.updateLabelByComboBox($("#contact-topic"));
        });
    },
    toggleAgreementFields: function () {
        // Reset checkmark on page load
        if (newsletterAgreement.is(":checked")) {
            newsletterAgreement.trigger("click");
        }
        // Reset additional fields on page load
        resetContactAdditionalFields();

        // Toggle additional fields on checkmark change event
        newsletterAgreement.on("change", function () {
            const isChecked = newsletterAgreement.is(":checked");
            const requiredFields = ["#register-day", "#register-month", "#register-year", "#countryOfResidence"];

            if (isChecked) {
                contactAdditionalData.removeClass("d-none");
                setFieldsRequired(requiredFields, true);
            } else {
                resetContactAdditionalFields();
                contactAdditionalData.addClass("d-none").find(".is-invalid").removeClass("is-invalid");
                setFieldsRequired(requiredFields, false);
            }
        });
    },
    subscribeContact: function () {
        formContactUs.submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr("action");
            const sourceDetail = form.parent().data("source-detail");
            $.spinner().start();
            var $serverErrorField = $(".contact-us-server-error");
            utils.setBirthdateInput(".register-birthdate");
            $serverErrorField.empty();

            recaptcha.setToken({ formSelector: "form.contactUs" }).then(function () {
                // Append the sourceDetail to the serialized form data
                const formData = sourceDetail ? form.serialize() + "&sourceDetail=" + encodeURIComponent(sourceDetail) : form.serialize();

                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: formData,
                    success: function (data) {
                        form.spinner().stop();
                        if (!data.success) {
                            formHelpers.loadFormErrors(form, data);
                            $.spinner().stop();
                            focusField($(".is-invalid").first());
                        } else {
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        form.spinner().stop();
                        const message = err.responseJSON.message;
                        if (!message) {
                            return;
                        }
                        $serverErrorField.append("<p>" + message + "</p>");
                        focusField($serverErrorField);
                    }
                });
            });
            return false;
        });
    },

    focusErrorField: function () {
        $(window).on("loadedFormErrors", function () {
            focusField($(".is-invalid").first());
        });
    }
};
